import { useState } from "react";
import { rpc, useAdminRows, fmtDateTime } from "@/lib/booking";
import { Card, Field, Select, SaveBtn, Ok, Err, SubTitle, useAction, smallBtn } from "./adminUI";

const ROLES = [["owner", "Proprietário (acesso total)"], ["manager", "Gerente (reservas, preços, pagamentos)"], ["staff", "Atendimento (reservas, sem pagamentos)"]];

export default function AdminsAdmin({ role }) {
    const admins = useAdminRows("admins", (sb) => sb.from("admin_users").select("*").order("created_at"));
    const audit = useAdminRows("audit", (sb) => sb.from("admin_audit_log").select("*").order("created_at", { ascending: false }).limit(50));
    const [f, setF] = useState({ email: "", role: "staff" });
    const { run, busy, msg, err } = useAction();
    const isOwner = role === "owner";

    return (
        <>
            <Card className="space-y-4">
                <SubTitle>Perfis e permissões de administradores</SubTitle>
                {(admins.data || []).map((a) => (
                    <div key={a.user_id} className="flex flex-wrap items-center justify-between gap-3 text-sm" data-testid={`admin-row-${a.user_id}`}>
                        <span>{a.email || a.user_id} · {ROLES.find((r) => r[0] === a.role)?.[0] || a.role}</span>
                        {isOwner && <button className={smallBtn} disabled={busy} onClick={() => window.confirm("Remover acesso?") && run(() => rpc("admin_remove_admin", { p_user: a.user_id }), "Removido")}>Remover</button>}
                    </div>
                ))}
                {isOwner ? <>
                    <div className="grid gap-4 sm:grid-cols-2">
                        <Field label="E-mail (usuário já criado no Supabase Auth)" value={f.email} onChange={(v) => setF({ ...f, email: v })} testid="admins-email" />
                        <Select label="Perfil" value={f.role} onChange={(v) => setF({ ...f, role: v })} options={ROLES} testid="admins-role" />
                    </div>
                    <div className="flex items-center justify-end gap-3"><Ok msg={msg} /><Err msg={err} />
                        <SaveBtn saving={busy} testid="admins-save" onClick={() => run(() => rpc("admin_set_admin", { p_email: f.email, p_role: f.role }))}>Salvar perfil</SaveBtn></div>
                    <p className="text-xs text-dim">Senhas nunca são definidas aqui: crie o usuário em Supabase → Authentication → Users (convite por e-mail) e depois atribua o perfil.</p>
                </> : <p className="text-xs text-dim">Somente o proprietário gerencia administradores.</p>}
            </Card>
            {role !== "staff" && <Card className="space-y-2">
                <SubTitle>Log administrativo (últimas 50 alterações)</SubTitle>
                {(audit.data || []).map((l) => <p key={l.id} className="text-xs text-dim">{fmtDateTime(l.created_at)} · {l.table_name} · {l.op} · {l.row_ref.slice(0, 12)}</p>)}
                {audit.isError && <p className="text-xs text-dim">Log indisponível (aplique supabase/plataforma.sql).</p>}
            </Card>}
        </>
    );
}
